import { doc, getDoc, setDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { getCurrentUserId } from '../utils/userStorage';

const getUserProjectsDoc = () => {
  const userId = getCurrentUserId();
  return doc(db, 'smm_user_data', userId, 'projects', 'projects');
};

export const getProjectsSnapshot = async () => {
  const snapshot = await getDoc(getUserProjectsDoc());
  const projects = snapshot.data()?.projects ?? [];
  return Array.isArray(projects) ? projects : [];
};

export const onProjectsChange = (callback) => {
  return onSnapshot(
    getUserProjectsDoc(),
    (snapshot) => callback(snapshot.data()?.projects ?? [], null),
    (error) => callback([], error),
  );
};

export const updateProjects = async (projects) => {
  await setDoc(getUserProjectsDoc(), { projects: Array.isArray(projects) ? projects : [] });
};
